<template>
  <span :style="setBillingStatusColor()">
    {{ translateBillingStatus() }}
  </span>
</template>

<script>
import { INVOICE_STATUS } from '../../modules/invoice/constants';
import { setPanoramaInvoiceStatusColor } from '../../modules/panorama/utils';

export default {
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    translateBillingStatus() {
      return INVOICE_STATUS[this.value];
    },
    setBillingStatusColor() {
      return setPanoramaInvoiceStatusColor(INVOICE_STATUS[this.value]);
    },
  },
};
</script>
